import { useTranslation } from 'react-i18next';
import { Box } from '@chakra-ui/react';

import { TextSemiBold } from 'UiKit/typography';

import { useStockPromoState } from 'View/stock-promo/state';

import styles from './styles.module.css';

const Tab = () => {
  const { selectedTab, updateState, updateFilterState } = useStockPromoState();
  const { t } = useTranslation('stock-promo');

  const handleChangeTab = ({ selectedTab }) => {
    updateState({ selectedTab });
    updateFilterState({ page: 1 });
  };

  return (
    <Box className={styles['tab__container']}>
      <Box
        className={`${selectedTab === 'stock' && styles['tab__item--active']} ${styles['tab__item']}`}
        onClick={() => handleChangeTab({ selectedTab: 'stock' })}
      >
        <TextSemiBold className={selectedTab === 'stock' ? styles['tab__item-text--active'] : styles['tab__item-text']}>{t('tab.stock')}</TextSemiBold>
      </Box>
      <Box
        className={`${selectedTab === 'promo' && styles['tab__item--active']} ${styles['tab__item']}`}
        onClick={() => handleChangeTab({ selectedTab: 'promo' })}
      >
        <TextSemiBold className={selectedTab === 'promo' ? styles['tab__item-text--active'] : styles['tab__item-text']}>{t('tab.promo')}</TextSemiBold>
      </Box>
    </Box>
  );
};

export default Tab;
